import type { ReactNode } from 'react'
import styles from './Header.module.css'

type HeaderProps = {
	left?: ReactNode
	center?: ReactNode
	right?: ReactNode
}

// Three-slot bar (left / center / right). The generic app-title was dropped;
// the center slot stays and takes per-page content (e.g. a detail title).
export const Header = ({ left, center, right }: HeaderProps) => {
	return (
		<header className={styles.header}>
			<div className={styles.left}>{left}</div>
			<div className={styles.center}>{center}</div>
			<div className={styles.right}>{right}</div>
		</header>
	)
}
